import React, { useContext } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useLocation } from '@reach/router';
import { Button as ZacButton } from '@zydalabs/zac-react';

import { Text } from 'components/service';
import * as translations from 'constants/translations';
import { context as userContext } from 'context/user';
import { context as featureBlockingContext } from 'context/feature-blocking';
import { context as localeContext } from 'context/locale';
import { Button, Modal } from 'components/kit';
import { ReactComponent as SettingsIcon } from 'assets/settings.svg';
import { ACCESS_MAP_KEYS } from 'constants/featureAccessMatrix';
import FeatureAccess from 'common/lib/FeatureAccess';
import ItemTrackingBlocked from 'pages/menu/overview/BasicDetails/ItemTrackingBlocked';
import TrackingTypeChange from './TrackingTypeChange';

const ItemEditPopUp = ({ menuItemDataTrack, productId, settings = false }) => {
  const { lang, translate } = useContext(localeContext);
  const { selectedStore } = useContext(userContext);
  const { featureAccess } = useContext(featureBlockingContext);
  const featureFeatureAccess = featureAccess.get(ACCESS_MAP_KEYS.FEATURES);

  const location = useLocation();
  const {
    ITEM_TRACKING: { isBlocked },
  } = featureFeatureAccess?.get(FeatureAccess.getFeaturePath(location?.pathname, selectedStore.id));

  return (
    <div>
      <Modal>
        {({ open }) => (
          <>
            <Button
              kind="transparent"
              onClick={() =>
                open({
                  size: isBlocked ? 'max-w-xl' : 'max-w-sm',
                  title: (
                    <div className={cx('flex justify-between items-center', lang === 'ar' && 'flex-row-reverse')}>
                      <div className="flex flex-col">
                        <Text className="text-xl leading-5 font-semibold" value={translations.ITEM_TRACKING_SETTINGS} />
                      </div>
                    </div>
                  ),
                  body: isBlocked ? (
                    <div className="px-4">
                      <ItemTrackingBlocked lang={lang} inTrackingPage />
                      <div className="pt-4">
                        <ZacButton
                          onClick={() => {
                            if (window.Intercom) window.Intercom('show');
                          }}
                          type="button"
                          size="large"
                          isFluid
                          rounded
                          text={translate(translations.UPGRADE_YOUR_FREE_PLAN)}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="mt-2 mb-0 mx-auto px-4">
                      <div className="flex flex-col items-center">
                        <div className="my-0 mx-0">
                          <Text
                            value={translations.ITEM_TRACKING}
                            className={cx('font-medium text-base', lang === 'ar' ? 'text-right' : 'text-left')}
                          />
                          <div>
                            <TrackingTypeChange menuItemDataTrack={menuItemDataTrack} productId={productId} />
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                })
              }
            >
              {settings ? <SettingsIcon /> : <Text value={translations.ENABLE_TRACKING} />}
            </Button>
          </>
        )}
      </Modal>
    </div>
  );
};

ItemEditPopUp.propTypes = {
  settings: PropTypes.bool,
  productId: PropTypes.string.isRequired,
  menuItemDataTrack: PropTypes.string.isRequired,
};

export default ItemEditPopUp;
